import { animated, useSpring } from "react-spring";

export const AnimatedNumber = ({
    value,
    delay,
    suffix = "",
}: {
    value: number;
    delay: number;
    suffix?: string;
}) => {
    const props = useSpring({
        from: { number: 0 },
        number: value,
        delay: delay,
        config: { mass: 1, tension: 100, friction: 26 },
    });

    return (
        <animated.span>
            {props.number.to((n) => `${n.toFixed(0)}${suffix}`)}
        </animated.span>
    );
};
